if (!customElements.get('size-chart-list')) {
  customElements.define('size-chart-list', class SizeChartList extends HTMLElement {
    constructor() {
      super();
      this.onClick = this.onClick.bind(this);
      this.onChange = this.onChange.bind(this);
      this.onKeydown = this.onKeydown.bind(this);
      this.lastCharts = new Map();
    }

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      this.addEventListener('change', this.onChange);
      this.addEventListener('keydown', this.onKeydown);
      const jumpsuitHash = ['#jumpsuits', '#jumpsuit-measuring'].includes(window.location.hash);
      const selected = (jumpsuitHash && this.querySelector('[data-chart-family="jumpsuit"]')) || this.querySelector('[data-chart-tab][aria-selected="true"]') || this.querySelector('[data-chart-tab]');
      if (selected) this.selectTab(selected, false);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.removeEventListener('change', this.onChange);
      this.removeEventListener('keydown', this.onKeydown);
    }

    selectTab(tab, announce = true) {
      if (!tab || !this.contains(tab)) return;
      const family = tab.dataset.chartFamily;
      this.dataset.family = family;
      this.dataset.length = tab.dataset.chartLength;
      for (const item of this.querySelectorAll('[data-dress-only]')) item.hidden = family === 'jumpsuit';
      const measuringNav = this.querySelector('[data-measuring-nav]');
      if (measuringNav) {
        if (!measuringNav.dataset.dressTarget) measuringNav.dataset.dressTarget = measuringNav.getAttribute('href');
        measuringNav.setAttribute('href', family === 'jumpsuit' ? `#${this.dataset.jumpsuitMeasuring}` : measuringNav.dataset.dressTarget);
      }
      for (const item of this.querySelectorAll('[data-special-family]')) item.hidden = item.dataset.specialFamily !== family;
      for (const item of this.querySelectorAll('[data-flower-faq]')) item.hidden = family !== 'flower';
      for (const guide of this.querySelectorAll('[data-guide-family]')) guide.hidden = guide.dataset.guideFamily !== family;
      for (const label of this.querySelectorAll('[data-selected-hem]')) label.textContent = tab.dataset.chartLabel;
      this.lastCharts.set(family, tab.dataset.chartHandle);
      for (const button of this.querySelectorAll('[data-family-button]')) {
        button.setAttribute('aria-pressed', String(button.dataset.familyButton === family));
      }
      for (const candidate of this.querySelectorAll('[data-chart-tab]')) {
        const selected = candidate === tab;
        candidate.hidden = candidate.dataset.chartFamily !== family;
        candidate.setAttribute('aria-selected', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
        const panel = this.querySelector(`#${CSS.escape(candidate.getAttribute('aria-controls'))}`);
        if (panel) panel.hidden = !selected;
      }
      for (const guide of this.querySelectorAll('[data-adult-guide]')) guide.toggleAttribute('hidden', family !== 'adult');
      const number = this.querySelector('[data-hem-number]');
      if (number) number.textContent = family === 'adult' ? '04' : '03';
      if (announce) {
        const status = this.querySelector('[data-chart-status]');
        const familyButton = this.querySelector(`[data-family-button="${family}"]`);
        if (status) status.textContent = `${familyButton?.textContent.trim() || ''} · ${tab.dataset.chartLabel}`;
      }
    }

    onClick(event) {
      const familyButton = event.target.closest('[data-family-button]');
      if (familyButton && this.contains(familyButton)) {
        const family = familyButton.dataset.familyButton;
        const candidates = [...this.querySelectorAll('[data-chart-tab]')].filter(tab => tab.dataset.chartFamily === family);
        const remembered = this.lastCharts.get(family);
        const next = candidates.find(tab => tab.dataset.chartHandle === remembered) || candidates.find(tab => tab.dataset.chartLength === (family === 'adult' ? 'floor' : 'tea')) || candidates[0];
        this.selectTab(next);
        return;
      }
      const tab = event.target.closest('[data-chart-tab]');
      if (tab) this.selectTab(tab);
    }

    onChange(event) {
      if (!event.target.matches('[data-unit-input]')) return;
      this.dataset.unit = event.target.value;
      for (const table of this.querySelectorAll('[data-unit-table]')) table.hidden = table.dataset.unitTable !== event.target.value;
    }

    onKeydown(event) {
      const tab = event.target.closest('[data-chart-tab]');
      if (!tab || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
      const tabs = [...this.querySelectorAll('[data-chart-tab]')].filter(candidate => !candidate.hidden);
      const index = tabs.indexOf(tab);
      let next = index;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      event.preventDefault();
      this.selectTab(tabs[next]);
      tabs[next].focus();
    }
  });
}



